import ConversionForm from './ConversionForm';

function App() {
  return (
    <div>
      <ConversionForm />
    </div>
  );
}

export default App;
